// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui
import type {
  IRawStyle,
  ISearchBoxStyleProps,
  ISearchBoxStyles,
  IStyle,
  IStyleFunctionOrObject,
} from "@fluentui/react";
import { convertToCssObject } from "./convertToCssObject";

export const mergeCssFromPropsandCustomDefined = (
  styleFromProps: any,
  customDefinedStyles: any
) => {
  const cssStyles = {
    cssFromProps: convertToCssObject(styleFromProps as Object),
    customDefinedCss: convertToCssObject(customDefinedStyles as Object),
  };
  Object.assign(cssStyles.customDefinedCss, cssStyles.cssFromProps);
  return cssStyles;
};

export const getStyleSelectors = (
  style: string | IRawStyle | IStyle,
  className: string
) => {
  if (style) {
    const styleSelectors = (style as any).selectors;
    if (styleSelectors && styleSelectors[className]) {
      return styleSelectors[className] as React.CSSProperties;
    }
  }
  return null;
};

export const removeKeyFromDictonary = (
  obj: { [key: string | number]: string | number } | null,
  key: string
) => {
  if (obj != null && key in obj) {
    delete obj[key];
  }
};

export const getObjectFromStylesGeneric = (
  styles: IStyle | undefined
): { [key: string | number]: string | number } | null => {
  if (typeof styles === "object" && styles !== null) {
    let styleObj: { [key: string | number]: any } = {};
    if (Array.isArray(styles)) {
      (styles as Array<any>).forEach(function (item) {
        Object.keys(item).forEach(function (k) {
          styleObj[k] = item[k];
        });
      });
    } else {
      styleObj = styles;
    }
    return styleObj;
  }
  return null;
};

export const getCustomStyleSelectors = (
  style:
    | IStyleFunctionOrObject<ISearchBoxStyleProps, ISearchBoxStyles>
    | undefined,
  className: keyof ISearchBoxStyles
) => {
  if (style) {
    const styleSelector = style as ISearchBoxStyles;
    if (className === "root") {
      const rootClass = styleSelector[className] as IRawStyle;
      if (rootClass) {
        const { borderRadius, ...rest } = rootClass;
        styleSelector[className] = { ...rest };
      }
    }
    return styleSelector[className] as React.CSSProperties;
  }
  return null;
};
